import React from "react";
import { StyleSheet, View } from "react-native";
import { Text } from "native-base";
import { ChevronLeft } from "lucide-react-native";

import { useAppContext } from "../API/Context-API/AppContext";
import { webFont } from "../API/API";
import PressableWrapp from "./PressableReact/PressableWrapp";

interface BackButtonBackHomeProps {
  navigation?: any;
  JustResetToHome?: boolean;
  onPress?: () => void;
}

const createStyles = (scaleAll: number, isSmallVersion: boolean, isMediumVersion: boolean) =>
  StyleSheet.create({
    wrap: {
      alignSelf: "flex-start",
      marginLeft: isSmallVersion ? 10 * scaleAll : 20 * scaleAll,
      marginTop: isSmallVersion ? 8 * scaleAll : 10 * scaleAll,
    },
    button: {
      minHeight: 38 * scaleAll,
      borderRadius: 999,
      paddingHorizontal: isSmallVersion ? 10 * scaleAll : 12 * scaleAll,
      paddingVertical: 7 * scaleAll,
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center",
      gap: 4 * scaleAll,
      backgroundColor: "rgba(255,255,255,0.92)",
      borderWidth: 1,
      borderColor: "#ECE8E1",
      shadowColor: "#000000",
      shadowOpacity: 0.08,
      shadowRadius: 18,
      shadowOffset: { width: 0, height: 8 },
      elevation: 6,
    },
    iconBox: {
      width: 16 * scaleAll,
      height: 16 * scaleAll,
      alignItems: "center",
      justifyContent: "center",
      marginLeft: -1 * scaleAll,
    },
    text: {
      fontFamily: webFont("Inter"),
      fontSize: isSmallVersion ? 13 * scaleAll : isMediumVersion ? 13.5 * scaleAll : 14 * scaleAll,
      lineHeight: isSmallVersion ? 16 * scaleAll : 17 * scaleAll,
      color: "#1F1D19",
      fontWeight: "600",
    },
  });

export const BackButtonBackHome: React.FC<BackButtonBackHomeProps> = React.memo(
  ({ navigation, JustResetToHome = false, onPress }) => {
    const { isSmallVersion, isMediumVersion, scaleAll } = useAppContext();

    const styles = React.useMemo(
      () => createStyles(scaleAll, isSmallVersion, isMediumVersion),
      [isMediumVersion, isSmallVersion, scaleAll]
    );

    const label = React.useMemo(() => {
      if (onPress) {
        return "Назад";
      }

      if (typeof window !== "undefined" && window.history.length > 1) {
        return "Назад";
      }
      return "Домой";
    }, [onPress]);

    const handlePress = () => {
      if (onPress) {
        onPress();
        return;
      }

      if (JustResetToHome) {
        if (typeof window !== "undefined") {
          window.location.href = "/";
        }
        return;
      }

      if (navigation?.canGoBack?.()) {
        navigation.goBack();
        return;
      }

      if (typeof window !== "undefined" && window.history.length > 1) {
        window.history.back();
        return;
      }

      if (typeof window !== "undefined") {
        window.location.href = "/";
      }
    };

    return (
      <View style={styles.wrap}>
        <PressableWrapp onPress={handlePress} activeOpacity={0.84} style={styles.button}>
          <View style={styles.iconBox}>
            <ChevronLeft color="#1F1D19" size={14 * scaleAll} />
          </View>
          <Text selectable={false} style={styles.text}>
            {label}
          </Text>
        </PressableWrapp>
      </View>
    );
  }
);
